/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molecular weight (g/mol)`)
};

const es_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecular (g/mol)`)
};

const de_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molekulargewicht (g/mol)`)
};

const nl_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molecuulgewicht (g/mol)`)
};

const fr_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse moléculaire (g/mol)`)
};

const it_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecolare (g/mol)`)
};

const pt_br2_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecular (g/mol)`)
};

const pt_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa molecular (g/mol)`)
};

const ja_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量 (g/mol)`)
};

const zh_massmol_field_mw = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量（g/mol）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_field_mw = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_field_mw(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_field_mw", locale)
	if (locale === "en") return en_massmol_field_mw(inputs)
	if (locale === "es") return es_massmol_field_mw(inputs)
	if (locale === "de") return de_massmol_field_mw(inputs)
	if (locale === "nl") return nl_massmol_field_mw(inputs)
	if (locale === "fr") return fr_massmol_field_mw(inputs)
	if (locale === "it") return it_massmol_field_mw(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_field_mw(inputs)
	if (locale === "pt") return pt_massmol_field_mw(inputs)
	if (locale === "ja") return ja_massmol_field_mw(inputs)
	return zh_massmol_field_mw(inputs)
};